import { SignageOrientation } from '../../types/signage';

export interface IPreviewWindow {
  /** Size of the media window as a share (0-100) of the media area. */
  widthPercent: number;
  heightPercent: number;
  /** Portrait scales the media to the window's height, landscape to its width. */
  fit: 'height' | 'width';
  /** Above 100 the media is enlarged beyond the window and cropped. */
  zoom: number;
}

/**
 * Mirrors the kiosk app: the scale shrinks the window (height in portrait, width in landscape)
 * up to 100, and above 100 the window stays full size while the media is enlarged inside it.
 */
export const previewWindow = (orientation: SignageOrientation | undefined, scalePercent: number | undefined): IPreviewWindow => {
  const landscape = orientation === 'landscape';
  const scale = scalePercent && scalePercent >= 1 ? scalePercent : 100;
  const share = Math.min(scale, 100);
  return {
    widthPercent: landscape ? share : 100,
    heightPercent: landscape ? 100 : share,
    fit: landscape ? 'width' : 'height',
    zoom: Math.max(scale, 100) / 100,
  };
};
